import * as React from 'react';
export var WishWidget = function WishWidget(props) {
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "\n\t\t\t<WishWidget " + propsToString(props) + "/>\n\t\t"
    }
  });
};
export var TravelPlanWidget = function TravelPlanWidget(props) {
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "\n\t\t\t<TravelPlanWidget " + propsToString(props) + "/>\n\t\t"
    }
  });
};
export var WishCounterWidget = function WishCounterWidget(props) {
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "\n\t\t\t<div class=\"stick-to-bottom\">\n\t\t\t\t<WishCounterWidget " + propsToString(props) + "/>\n\t\t\t</div>\n\t\t"
    }
  });
};
export var ShareTripWidget = function ShareTripWidget(props) {
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "\n\t\t\t<ShareTripWidget " + propsToString(props) + "/>\n\t\t"
    }
  });
};

function propsToString(props) {
  return Object.keys(props).map(function (item) {
    return camelToSnakeCase(item) + "=\"" + props[item] + "\"";
  }).join(' ');
}

function camelToSnakeCase(str, snakeChar) {
  if (snakeChar === void 0) {
    snakeChar = '-';
  }

  return str[0].toLowerCase() + str.slice(1).replace(/([A-Z])/g, function (g) {
    return snakeChar + g[0].toLowerCase();
  });
}